// extracted by mini-css-extract-plugin
export default {"err":"FormErr_err__6-L8Q","shake":"FormErr_shake__IHy6e"};